module.exports = __webpack_public_path__ + "img/02.dcebf135.jpg";